let group = {
    path: "group",
    name: "group",
    redirect: "/group/list",
    component: () => import("@/views/group/index.vue"),
    meta: {
        name: "团单",
    },
    children: [
        {
            path: "list",
            name: "goodlist",
            component: () => import("@/views/group/pages/list.vue"),
            meta: {
                name: "团单列表",
            },
        },
        {
            path: "goods",
            name: "goodDetail",
            component: () => import("@/views/group/pages/goods.vue"),
            meta: {
                name: "团单商品",
            },
        },
    ],
};

export default group;